import { useEffect } from 'react';

const BRAND = 'Wallfeed';

/**
 * Sets the browser tab title for a page. Called by each route rather than driven
 * from the router, because the router is a flat list with no layout element to
 * hang this off, and several pages only learn what to call themselves once their
 * data has loaded.
 *
 * Pass `undefined` while a page is still deciding - the title then stays as it
 * is instead of flashing the bare brand for a moment and settling afterwards.
 */
export function useDocumentTitle(page?: string): void {
  useEffect(() => {
    if (page === undefined) return;
    document.title = page ? `${BRAND} · ${page}` : BRAND;
  }, [page]);
}
